(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["al-media-proof-only"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('al-media-proof')) {
    customElements.define('al-media-proof', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.al-media-proof__accessible-toggle');
        this.group = this.querySelector('.al-media-proof__group');
        this.viewport = this.querySelector('.al-media-proof__viewport');
        this.track = this.querySelector('.al-media-proof__track');
        if (!this.button || !this.viewport || !this.track || !this.group || !this.group.children.length) return;
        this.startManualScroll = () => {
          if (this.manualScroll) return;
          const animation = this.track.getAnimations()[0];
          if (!animation) return;
          const duration = Number(animation.effect.getComputedTiming().duration);
          if (!duration) return;
          this.manualScroll = true;
          this.viewport.setAttribute('data-keyboard-scroll', '');
          this.viewport.scrollLeft = (Number(animation.currentTime) % duration) / duration * this.group.getBoundingClientRect().width;
          this.updateControl();
        };
        this.onBlur = () => {
          if (!this.manualScroll) return;
          const animation = this.track.getAnimations()[0];
          const width = this.group.getBoundingClientRect().width;
          if (animation && width) {
            const duration = Number(animation.effect.getComputedTiming().duration);
            animation.currentTime = (this.viewport.scrollLeft % width) / width * duration;
          }
          this.viewport.scrollLeft = 0;
          this.manualScroll = false;
          this.viewport.removeAttribute('data-keyboard-scroll');
          this.updateControl();
        };
        this.updateControl = () => {
          if (this.motionQuery.matches) {
            this.viewport.setAttribute('role', 'region');
            this.button.hidden = true;
            this.viewport.setAttribute('aria-label', '掲載先一覧。左右キーでスクロールできます');
          } else {
            this.viewport.setAttribute('role', 'region');
            this.button.hidden = false;
            const paused = this.hasAttribute('data-paused');
            this.button.setAttribute('aria-pressed', String(paused));
            this.viewport.setAttribute('aria-label', `掲載先一覧。${this.manualScroll ? '左右キーで閲覧中' : paused ? '自動スクロール停止中' : '自動スクロール再生中'}。タップまたはEnter・スペースで切り替え、左右キーで一覧を移動できます`);
          }
        };
        this.onToggle = () => {
          if (this.motionQuery.matches) return;
          this.onBlur();
          this.toggleAttribute('data-paused');
          this.updateControl();
        };
        this.onKeyDown = (event) => {
          if (!this.motionQuery.matches && event.repeat && (event.key === 'Enter' || event.key === ' ')) { event.preventDefault(); return; }
          if (event.key === 'Enter' || event.key === ' ') {
            if (!this.motionQuery.matches) {
              event.preventDefault();
              this.onToggle();
            }
          } else if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            this.startManualScroll();
          }
        };
        this.onMotionChange = () => { this.onBlur(); this.updateControl(); };
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.motionQuery.addEventListener('change', this.onMotionChange);
        this.onPointerDown = (event) => { this.pointerStart = [event.clientX, event.clientY]; this.dragged = false; };
        this.onPointerMove = (event) => {
          if (this.pointerStart && Math.hypot(event.clientX - this.pointerStart[0], event.clientY - this.pointerStart[1]) > 8) this.dragged = true;
        };
        this.onPointerEnd = () => { this.pointerStart = null; };
        this.onClick = () => { if (!this.dragged) this.onToggle(); this.dragged = false; };
        this.viewport.addEventListener('pointerdown', this.onPointerDown);
        this.viewport.addEventListener('pointermove', this.onPointerMove);
        this.viewport.addEventListener('pointerup', this.onPointerEnd);
        this.viewport.addEventListener('pointercancel', this.onPointerEnd);
        this.viewport.addEventListener('click', this.onClick);
        this.button.addEventListener('click', this.onToggle);
        this.viewport.addEventListener('keydown', this.onKeyDown);
        this.viewport.addEventListener('blur', this.onBlur);
        this.observer = new ResizeObserver(() => this.measure());
        this.observer.observe(this.group);
        this.measure();
        this.setAttribute('data-ready', '');
        this.updateControl();
      }
      measure() {
        const speed = Math.max(20, Math.min(60, Number(this.dataset.speed) || 30));
        const duration = this.group.getBoundingClientRect().width / speed;
        if (duration > 0) this.style.setProperty('--proof-duration', `${duration}s`);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.viewport?.removeEventListener('click', this.onClick);
        this.viewport?.removeEventListener('pointerdown', this.onPointerDown);
        this.viewport?.removeEventListener('pointermove', this.onPointerMove);
        this.viewport?.removeEventListener('pointerup', this.onPointerEnd);
        this.viewport?.removeEventListener('pointercancel', this.onPointerEnd);
        this.button?.removeEventListener('click', this.onToggle);
        this.viewport?.removeEventListener('keydown', this.onKeyDown);
        this.motionQuery?.removeEventListener('change', this.onMotionChange);
        this.viewport?.removeEventListener('blur', this.onBlur);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
